import { RouterModule, Routes } from "@angular/router";
import { DocumentoObrasEditComponent } from "./components/documento-obras-edit/documento-obras-edit.component";
import { ObrasAdminExportarComponent } from "./components/obras-admin-exportar/obras-admin-exportar.component";
import { ObrasAdminGeralComponent } from "./components/obras-admin-geral/obras-admin-geral.component";
import { ObrasAdminStatusEditComponent } from "./components/obras-admin-status-edit/obras-admin-status-edit.component";
import { ObrasAdminStatusListComponent } from "./components/obras-admin-status-list/obras-admin-status-list.component";
import { ObrasEditComponent } from "./components/obras-edit/obras-edit.component";
import { PesquisaGeralObrasComponent } from "./components/pesquisa-geral-obras/pesquisa-geral-obras.component";
import { DocumentoObrasFiltersResolver, DocumentoObrasResolver } from "./resolver/documento-obras.resolver";
import { ObrasAdminGeralResolver } from "./resolver/obras-admin-geral.resolver";
import { QrObraAdminStatusResolver } from "./resolver/obras-admin-status.resolver";
import { QrObraCombosResolver, QrObraFiltersResolver } from "./resolver/qr-obras-filters.resolver";
import { QrObraVerifyProjectResolver } from "./resolver/qr-obras-verify-project.resolver";
import { QrObraResolver } from "./resolver/qr-obras.resolver";
  
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'pesquisa-geral',
        component: PesquisaGeralObrasComponent,
        resolve: { filters: QrObraFiltersResolver }
      },
      {
        path: 'obra',
        children: [
          { path: '', redirectTo: 'adicionar', pathMatch: "full" },
          {
            path: 'adicionar',
            component: ObrasEditComponent,
            resolve: { list: QrObraCombosResolver, projeto: QrObraVerifyProjectResolver }
          },
          {
            path: ':id',
            component: ObrasEditComponent,
            resolve: { list: QrObraCombosResolver, entity: QrObraResolver }
          },
        ],
      },
      {
        path: 'documento',
        children: [
          {
            path: 'adicionar',
            component: DocumentoObrasEditComponent,
            resolve: { list: DocumentoObrasFiltersResolver }
          },
          {
            path: ':id',
            component: DocumentoObrasEditComponent,
            resolve: { list: DocumentoObrasFiltersResolver, entity: DocumentoObrasResolver }
          },
        ],
      },
      {
        path: 'geral',
        component: ObrasAdminGeralComponent,
        resolve: { entity: ObrasAdminGeralResolver }
      },
      {
        path: 'exporta',
        component: ObrasAdminExportarComponent,
      },
      {
        path: 'status',
        children: [
          {
            path:'adicionar', 
            component: ObrasAdminStatusEditComponent
          },
          {
            path:':id', 
            component: ObrasAdminStatusEditComponent,
            resolve: { entity: QrObraAdminStatusResolver }
          },  
          {
            path: '',
            component: ObrasAdminStatusListComponent,
          }
        ]
      }
    ]
  }
];

export const QrObrasRoutes = RouterModule.forChild(routes);